export default __webpack_public_path__ + "static/out_sourcing4-b413906cd112752d28ddef51fe7afd2d.jpg";